import type {CheckoutPrice} from './CheckoutPrice';

export type OrderItem = {
  id: string;
  name: string;
  price: CheckoutPrice;
  deductible: boolean;
  itemContextId: string | null;
};
